import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@vwfs-bronson/bronson-react';
import { Container } from './Container';

export const StateInitial = ({ onRequestCallback }: { onRequestCallback: () => void }) => {
    const { t } = useTranslation('early-settlement');

    return (
        <Container title={t('dealer-callback.headline')}>
            <ul className="o-list-bare">
                <li className="u-mb-small">
                    <p className="u-mb-xsmall">1. {t('dealer-callback.contact-us-section.text')}</p>
                    <a href={t('dealer-callback.contact-us-section.link')}>
                        <Button
                            secondary
                            id="contact-us-button"
                            aria-label={t('dealer-callback.contact-us-section.button')}
                        >
                            {t('dealer-callback.contact-us-section.button')}
                        </Button>
                    </a>
                </li>
                <li className="u-mb-small">
                    <p className="u-mb-xsmall">2. {t('dealer-callback.request-callback-section.text')}</p>
                    <Button
                        secondary
                        id="request-callback-button"
                        aria-label={t('dealer-callback.request-callback-section.button')}
                        onClick={onRequestCallback}
                    >
                        {t('dealer-callback.request-callback-section.button')}
                    </Button>
                </li>
            </ul>
        </Container>
    );
};
